import styled from '@emotion/styled';
import { Stack } from '@mui/material';

export const StyledHistoryItem = styled(Stack)`
  gap: 4px;
  padding: 12px;
  cursor: pointer;
  align-items: center;
  border-radius: 4px;

  :hover {
    background: var(--dk-purple-soft, #fbf4fa);
  }
`;

export const DeleteIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M17.5 6.5L6.5 17.5"
      stroke="#888D96"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5 6.5L17.5 17.5"
      stroke="#888D96"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
